import React from 'react';
import { AlertComponentType, AlertContainer } from './styles';

interface IProps {
  type: AlertComponentType;
  message: string;
}

const AlertComponent: React.FC<IProps> = ({ type, message, children }) => {
  return (
    <AlertContainer alertType={type}>
      {children}
      {message}
    </AlertContainer>
  );
};

export default AlertComponent;
